module.exports = __webpack_public_path__ + "static/media/bicoNylon.e6835214.png";